/* eslint-disable react/no-this-in-sfc */
import GKCharts from "components/GKCharts";
import Highcharts from "highcharts/highstock";
import { useMemo } from "react";
import { formatYAxisLabel } from "utils/helpers";

interface TransactionData {
  type: string;
  date: string;
  price: number | string;
  quantity: number | string;
  amount: number;
}

interface TransactionItem {
  type: string;
  date: string;
  price: number | string;
  quantity?: number | string;
  amount?: number;
}

interface Props {
  data: any;
}

const HoldingBuySellChat = ({ data }: Props) => {
  console.log("HoldingBuySellChat data:", data);
  console.log("data?.data?.data?.hmpLists:", data?.data?.data?.hmpLists);
  console.log("data?.data?.data?.data:", data?.data?.data?.data);

  const events: TransactionData[] = data?.data?.data?.hmpLists || [];
  const transactionData: TransactionItem[] = data?.data?.data?.data || [];

  // Debug: Log all transaction types
  console.log("All transaction data:", transactionData);
  console.log(
    "Transaction types:",
    transactionData.map((item) => item.type),
  );
  const uniqueTypes = [...new Set(transactionData.map((item) => item.type))];
  console.log("Unique types:", uniqueTypes);

  const chartDataOption = useMemo(() => {
    return {
      chart: {
        borderRadius: 5,
        backgroundColor: "var(--white)",
        height: 650,
      },
      title: {
        text: undefined as string | undefined,
      },
      legend: {
        enabled: true,
        layout: "horizontal",
        align: "center",
        verticalAlign: "top",
      },

      xAxis: {
        type: "datetime",
        labels: {
          formatter(this: any) {
            return Highcharts.dateFormat("%b %e, %Y", this.value);
          },
        },
      },

      yAxis: {
        min: 0,
        labels: {
          formatter(this: any) {
            return formatYAxisLabel(this.value);
          },
        },
      },

      tooltip: {
        shared: true,
        xDateFormat: "%b %e, %Y",
      },

      series: [
        {
          name: "Price",
          data: events.map((item) => [
            new Date(item.date).getTime(),
            Number(item.price),
          ]),
          color: "#007BFF",
          type: "line",
          lineWidth: 1,
          marker: {
            enabled: false,
          },
          states: {
            hover: {
              enabled: false,
            },
          },
          enableMouseTracking: false,
        },
        ...(() => {
          console.log("Generating series for types:", uniqueTypes);

          const typeColors: Record<string, string> = {
            BUY: "#15803D",
            SELL: "#C35245",
            DIVIDEND: "#D5864E",
          };

          const darkColors = [
            "#2c3e50",
            "#34495e",
            "#7b241c",
            "#641e16",
            "#4a235a",
            "#6e2c00",
            "#1b4f72",
            "#5d6d7e",
            "#1a1a1a",
            "#0e6655",
          ];

          return uniqueTypes.map((type, index) => {
            const typeData = transactionData.filter(
              (item) => item.type === type,
            );
            console.log(`Type ${type} has ${typeData.length} items:`, typeData);

            return {
              name: type,
              type: "scatter",
              data: typeData
                .map((item) => {
                  let price = 0;
                  if (typeof item.price === "string") {
                    // Extract number from strings like "11.0/share"
                    const match = item.price.match(/[\d.]+/);
                    price = match ? parseFloat(match[0]) : 0;
                  } else {
                    price = Number(item.price);
                  }

                  const timestamp = new Date(item.date).getTime();

                  // Count how many transactions of this type exist on this date
                  const sameDateTransactions = typeData.filter(
                    (otherItem) =>
                      new Date(otherItem.date).getTime() === timestamp,
                  );
                  const transactionIndex = sameDateTransactions.findIndex(
                    (otherItem) => otherItem === item,
                  );

                  // Add small horizontal offset (in milliseconds) to separate dots
                  // Spread them across a few hours but keep same date
                  const offset = transactionIndex * 7200000; // 2 hours offset per transaction

                  return [timestamp + offset, price];
                })
                .filter(([, price]) => !Number.isNaN(price) && price > 0),
              color: typeColors[type] || darkColors[index % darkColors.length],
              marker: {
                symbol: "circle",
                radius: 6,
                lineWidth: 1,
                lineColor: "#ffffff",
              },
              tooltip: {
                pointFormat: `<b>Type:</b> ${type}<br/><b>Price:</b> {point.y}<br/><b>Date:</b> {point.x:%b %e, %Y}`,
              },
              zIndex: 10,
            };
          });
        })(),
      ],
    };
  }, [events]);

  return <GKCharts chartOptions={chartDataOption} rangeSelector navigator />;
};

export default HoldingBuySellChat;
